import type * as React from 'react';
import { cn } from '@/lib/cn';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Zenith (WEB-100): o campo AFUNDA no branco (`--shadow-inset`) em vez de levar
        // borda 1px dura; o foco troca a sombra pelo ring teal e o fundo pelo card.
        // `min-h-9` e não `h-9`: altura travada em px não acompanha quem aumenta a fonte
        // do navegador e o Chrome corta a base das letras.
        'min-h-9 w-full min-w-0 rounded-xl border border-transparent bg-secondary/60 px-3 py-1 text-base shadow-(--shadow-inset) transition-[box-shadow,background-color] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:bg-card focus-visible:ring-[3px] focus-visible:ring-ring/50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
